import { UIKitIcon } from '../icon';

export const carIcon: UIKitIcon = {
  name: 'car',
  // tslint:disable-next-line: max-line-length
  data: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><path d="M5,21v3a1,1,0,0,0,1,1H8a1,1,0,0,0,1-1V23" '
  + 'fill="none" stroke="inherit" stroke-linecap="round" stroke-linejoin="round"/><path d="M23,23v1a1,1,0,0,0,1,1h2a1,1,'
  + '0,0,0,1-1V21" fill="none" stroke="inherit" stroke-linecap="round" stroke-linejoin="round"/><circle cx="9" cy="18.5"'
  + ' r="1.5" fill="none" stroke="inherit" stroke-miterlimit="10"/><circle cx="23" cy="18.5" r="1.5" fill="none" '
  + 'stroke="inherit" stroke-miterlimit="10"/><path d="M27,21V15.52a2,2,0,0,0-.25-1l-3.37-6A2,2,0,0,0,21.44,7H10.56A2,2,0,'
  + '0,0,8.62,8.51l-3.37,6a2,2,0,0,0-.25,1V21a2,2,0,0,0,2,2H25A2,2,0,0,0,27,21Z" fill="none" stroke="inherit" '
  + 'stroke-linecap="round" stroke-linejoin="round"/><path d="M7.79,10H5v1l3.47,2.6a2,2,0,0,0,1.2.4H22.33a2,2,0,0,0,1.2-.4L27,'
  + '11V10H24.21" fill="none" stroke="inherit" stroke-linejoin="round"/></svg>',
};
